<div style="min-height: 18rem" class="flex flex-column align-items-center justify-content-center" [ngClass]="{ spinner: aer_gtnm === undefined }">
  <div *ngIf="ciiRangesCurrentYear != null">
    <p-chart
      class="cii-rating-diagram"
      *ngIf="chartReady"
      type="doughnut"
      [data]="ciiRatingChartData"
      [options]="ciiRatingChartOptions"
      [plugins]="ciiRatingChartPlugins"></p-chart>
  </div>
</div>
